export default "__VITE_ASSET__DvtsOXal__"